//@ts-nocheck
import { getLatestSelectedKeyframeIndices, clearAllSpatialEaseOnKeyframe, getNearestFrameTime } from './keyframes';
import { applyBezierToPeak } from './bezier';
import { mapToValues, addArrayValues } from './math-utils';
import { validateCubicBezierX } from './validation';

const getValueDelta = (ogn, dst) => {
  if (ogn instanceof Array) {
    let res = []
    for (let i = 0; i < ogn.length; i++) {
      res.push(dst[i] - ogn[i]);
    }
    return res;
  } else {
    return Math.abs(dst - ogn);
  }
}

export const bounceEaseLayer = (req, comp, prop, values) => {
  let selectedIndices = getLatestSelectedKeyframeIndices(prop);
  let ognIdx = selectedIndices[selectedIndices.length - 2];
  let dstIdx = selectedIndices[selectedIndices.length - 1];
  let timeDelta = prop.keyTime(dstIdx) - prop.keyTime(ognIdx);
  let timeLerpMax = timeDelta * 5; //TODO: magic number here corresponds to UI visualization as initial bounce occurs at 1/5 of total time
  let currOgn = ognIdx
  let valueLerpMax = prop.keyValue(dstIdx) - prop.keyValue(ognIdx);
  //TODO: validation functions for values
  if (prop.matchName.includes('Opacity')) {
    if (valueLerpMax > 100) {
      valueLerpMax = 100;
    }
  }
  let keysframesToWrite = [];
  for (let i = 0; i < values.length; i++) {
    let peakDeltaLerp = ((values[i].dstLerpX - values[i].ognLerpX) / 2) + values[i].ognLerpX;
    let peakKfTimeOffset = peakDeltaLerp * timeLerpMax;
    let peakKfValue = mapToValues(valueLerpMax, values[i].peakLerpY); // SHOULD BE THIS PLUS DST VAL
    peakKfValue = addArrayValues(prop.keyValue(dstIdx), peakKfValue);
    // let peakKf = prop.addKey(peakKfTime);
    // prop.setValueAtKey(peakKf, peakKfValue);
    let dstLerp = values[i].dstLerpX;
    let dstKfTimeOffset = dstLerp * timeLerpMax;
    // currOgn = prop.addKey(destKfTime);
    // prop.setValueAtKey(currOgn, prop.keyValue(dstIdx));
    let cubicBez = validateCubicBezierX([values[i].mirrorPeakXCubic, values[i].mirrorPeakYCubic, values[i].dstXCubic, values[i].dstYCubic])
    let keyframe = {
      peakKfTimeOffset,
      peakKfValue,
      dstKfValue: prop.keyValue(dstIdx),
      dstKfTimeOffset,
      cubicBez
    }
    keysframesToWrite.push(keyframe);
    // if(prop.propertyValueType  == PropertyValueType.ThreeD_SPATIAL || prop.propertyValueType  == PropertyValueType.TwoD_SPATIAL) {
    //   clearSpatialOutEaseOnKeyframe(prop, peakKf - 1)
    // }
    // applyBezierToPeak(prop, peakKf, dstIdx, cubicBezVal);
  }
  return keysframesToWrite;
};

export const createBounceKeyframesOverwrite = (req, comp, prop, selectedIndices, newKeyframes) => {
  let finalSelectedKeyframeTime = prop.keyTime(selectedIndices[selectedIndices.length - 1]);
  let ognSelectedKeyframeTime = prop.keyTime(selectedIndices[selectedIndices.length - 2]);
  let finalKeyframeWriteTime = newKeyframes[newKeyframes.length - 1].dstKfTimeOffset + finalSelectedKeyframeTime;
  
  for (let i = prop.numKeys; i > 0; i--) {
    if (prop.keyTime(i) < finalKeyframeWriteTime && prop.keyTime(i) > finalSelectedKeyframeTime) {
      prop.removeKey(i);
    }
  }

  for (let i = 0; i < newKeyframes.length; i++) {
    let { peakKfTimeOffset,
      dstKfTimeOffset,
      peakKfValue,
      dstKfValue,
      cubicBez,} = newKeyframes[i]
      let peakKeyframeWriteTime = ognSelectedKeyframeTime + peakKfTimeOffset;
      let dstKeyframeWriteTime = ognSelectedKeyframeTime + dstKfTimeOffset;
      if (req.config.keyframeWriteAtTimeBehavior === 'nearest_frame') 
      {
        peakKeyframeWriteTime = getNearestFrameTime(comp, peakKeyframeWriteTime); 
        dstKeyframeWriteTime = getNearestFrameTime(comp, dstKeyframeWriteTime);
        if (peakKeyframeWriteTime === dstKeyframeWriteTime) return
      }
      //create peak keyframe
      let newPeakKf = prop.addKey(peakKeyframeWriteTime);
      //set peak keyframe value
      prop.setValueAtKey(newPeakKf, peakKfValue);
      //create destination keyframe
      let newDstKf = prop.addKey(dstKeyframeWriteTime);
      //set destination keyframe value
      prop.setValueAtKey(newDstKf, dstKfValue);
      applyBezierToPeak(prop, newPeakKf, selectedIndices[selectedIndices.length - 1], cubicBez);
  }
}

export const createBounceKeyframesStop = (req, comp, prop, selectedIndices, newKeyframes) => {
  let firstExistingKeyframeTime = Infinity
  let finalSelectedKeyframeTime = prop.keyTime(selectedIndices[selectedIndices.length - 1]);
  let ognSelectedKeyframeTime = prop.keyTime(selectedIndices[selectedIndices.length - 2]);

  for (let i = 1; i <= prop.numKeys; i++) {
    let curKeyTime = prop.keyTime(i)
    if (curKeyTime > finalSelectedKeyframeTime) {
        firstExistingKeyframeTime = curKeyTime;
        //TODO: look into potential issues with removing continuous easing on existing keyframes
        if(prop.propertyValueType  == PropertyValueType.ThreeD_SPATIAL || prop.propertyValueType  == PropertyValueType.TwoD_SPATIAL) {
          clearAllSpatialEaseOnKeyframe(prop, i)
          if (i + 1 <= prop.numKeys) clearAllSpatialEaseOnKeyframe(prop, i + 1)
        }
        break;
    }
  }

  for (let i = 0; i < newKeyframes.length; i++) {
    let { peakKfTimeOffset,
      dstKfTimeOffset,
      peakKfValue,
      dstKfValue,
      cubicBez,} = newKeyframes[i]

      let peakKeyframeWriteTime = ognSelectedKeyframeTime + peakKfTimeOffset;
      let dstKeyframeWriteTime = ognSelectedKeyframeTime + dstKfTimeOffset;
      if (req.config.keyframeWriteAtTimeBehavior === 'nearest_frame') 
      {
        peakKeyframeWriteTime = getNearestFrameTime(comp, peakKeyframeWriteTime); 
        dstKeyframeWriteTime = getNearestFrameTime(comp, dstKeyframeWriteTime);
        if (peakKeyframeWriteTime === dstKeyframeWriteTime) return
      }

      if (dstKeyframeWriteTime < firstExistingKeyframeTime) {
        //create peak keyframe
        let newPeakKf = prop.addKey(peakKeyframeWriteTime);
        //set peak keyframe value
        prop.setValueAtKey(newPeakKf, peakKfValue);
        //create destination keyframe
        let newDstKf = prop.addKey(dstKeyframeWriteTime);
        //set destination keyframe value
        prop.setValueAtKey(newDstKf, dstKfValue);
        applyBezierToPeak(prop, newPeakKf, selectedIndices[selectedIndices.length - 1], cubicBez);
    }
  }
}

//TODO: consider using this to create mode allowing user to specific angle and velocity of bounce
// var basicBounceEaseLayer = function basicBounceEaseLayer(prop, layerNum) {
//     var a = collectKeyframes(prop);
//     var incomingVal = a[a.length - 1]['curKeyValue'];
//     elev = degreesToRadians(75);
//     v = 1900;
//     e = .7;
//     f = .5;
//     gravity = 5000;
//     maxBounces = 11;
//     tLaunch = .5;
//     vy = v*Math.sin(elev);
//     vx = v*Math.cos(elev);
//     var numKeys = 2;
//     for (var i = 0; i < 3; i += .01) {
//       if (i >= tLaunch){
//         t = i - tLaunch;
//         tCur = 0;
//         segDur = 2*vy/g;
//         tNext = segDur;
//         d = 0; // x distance traveled
//         nb = 0; // number of bounces
//         while (tNext < t && nb <= maxBounces){
//           d += vx*segDur;
//           vy *= e;
//           vx *= f;
//           segDur *= e;
//           tCur = tNext;
//           tNext += segDur;
//           nb++
//         }
//         if(nb <= maxBounces){
//           delta = t - tCur;
//           x = d + delta*vx;
//           y = delta*(vy - g*delta/2);
//         }else{
//           x = d;
//           y = 0;
//         }
//         numKeys++
//         var newKeyframePosition = [incomingVal[0] + x, incomingVal[1] + (-y), incomingVal[2] + 0];
//         createKeyframe(prop, numKeys, i, newKeyframePosition);
//       }else
//         0
//     }
//   }